<template>
    <layout :brand="brand">
        <main class="page auth register">
            <header class="text-center mt-6 mb-16">
                <h1 class="font-bold text-2xl md:text-4xl leading-none">Aanmelden</h1>
            </header>

            <validation-observer v-slot="{ invalid, handleSubmit }">

                <div v-if="Object.keys($page.errors).length"  class="mb-10">
                    <div v-for="(error, index) in $page.errors" :key="`error-${index}`">
                        <div class="errors p-3 bg-danger text-white rounded-lg mb-2" v-for="(errorMessage, errorMessageIndex) in error" :key="`error-message-${errorMessageIndex}`">{{ errorMessage }}</div>
                    </div>
                </div>

                <form @submit.prevent="handleSubmit(submitRegistration)" novalidate class="mb-12">
                    <contact-details :fields="settings" />
                    <address-data />
                    <device-damage :fields="settings" />
                    <send-options />

                    <label for="terms" class="terms-check flex items-center mt-3 cursor-pointer">
                        <label for="terms" class="block m-0">
                            <input type="checkbox" v-model="agreedWithTerms" id="terms" name="terms" class="block">
                            <span class="checkmark" />
                        </label>

                        <span class="text-dark-600 font-medium pl-3">Ja, ik kennis genomen en ga akkoord met de <a href="https://bereikbaar.nu/algemene-voorwaarden" target="_blank" class="text-primary">algemene voorwaarden</a>.</span>
                    </label>

                    <p v-if="termsError" class="mt-1 text-danger">Ga akkoord met de algemene voorwaarden</p>

                    <button @click="checkErrors(invalid)" type="submit" class="bg-brand text-lg md:text-xl rounded-lg text-white font-semibold p-4 leading-6 w-full" :class="{ spinner: isLoading }">Aanmelden </button>
                </form>
            </validation-observer>
        </main>
    </layout>
</template>

<script>
import Layout from '@/layouts/Default';
import ContactDetails from '@/components/Register/ContactDetails';
import AddressData from '@/components/Register/AddressData';
import DeviceDamage from '@/components/Register/DeviceDamage';
import SendOptions from '@/components/Register/SendOptions';

export default {
    props: {
        brand: Object,
        settings: Object,
    },

    data() {
        return {
            agreedWithTerms: false,
            termsError: false,
            isLoading: false
        }
    },

    components: {
        ContactDetails,
        AddressData,
        DeviceDamage,
        SendOptions,
        Layout
    },

    computed: {
        registrationFormData() {
            return this.$store.state.registrationForm;
        }
    },

    methods: {
        checkErrors(invalid) {
            const errorElement = document.querySelector('.error');

            if (errorElement) {
                errorElement.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        },

        async submitRegistration() {
            if (!this.agreedWithTerms) {
                return this.termsError = true;
            } else {
                this.isLoading = true;
                await this.$inertia.post('/register', this.registrationFormData);
                this.isLoading = false;
            }
        }
    }
}
</script>

<style lang="scss">

.page.auth.register {

    form {

        .input-wrapper {
            > div {
                border: 1px solid #d2d6dc;
            }

            &.error > div {
                 border: 1px solid #EB5757;
            }
        }

        input, textarea, select, button {
            @apply outline-none shadow-none #{!important};

            &:focus, &:active {
                @apply outline-none shadow-none #{!important};
            }
        }
    }

    .terms-check {

		label {
			@apply relative;

			input {
				@apply absolute opacity-0 h-0 w-0 cursor-pointer;

				&:checked ~ .checkmark::after {
					content: '';
					@apply absolute w-4 h-4 rounded bg-brand;
					top: 0.25rem;
					left: 0.25rem;
				}
			}

			.checkmark {
				@apply block w-6 h-6 shadow bg-white rounded-lg;
				border: 1px solid #EEEEEE;
			}
		}
	}
}

.spinner {
    position: relative;
    color: transparent !important;
    pointer-events: none;
  }
  
  .spinner::after {
    content: '';
    position: absolute !important;
    top: calc(50% - (1em / 2));
    left: calc(50% - (1em / 2));
    display: block;
    width: 1em;
    height: 1em;
    border: 2px solid currentColor;
    border-radius: 9999px;
    border-right-color: transparent;
    border-top-color: transparent;
    animation: spinAround 1000ms infinite linear;
    color: white;
  }
  
  @keyframes spinAround {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

</style>
